import React, { useState,useRef,useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import DatePicker from 'react-datepicker';


function AddAssessment(arg) {
  const [show, setShow] = useState(arg.flag);
  const [title,setTitle] = useState("");
  const [desc,setDesc] = useState("");
  const [type,setType] = useState('');
  const [threshold,setThreshold] = useState("");
  const [duration, setDuration] = useState("");
  const [attemptsAllowed, setAttemptsAllowed] = useState(10);
  const [expiryDate, setExpiryDate] = useState(new Date(new Date().setFullYear(new Date().getFullYear() + 1)));
  const [todayDate, setTodayDate] = useState(new Date());
  const checkFlag = useRef(0);


  const handleClose = () => {
    setShow(false);
    arg.handler();
  }

  //Edit flow-populate values
  useEffect(() => {
    if(arg.edit){
      const {name,duration,description,passpercentage,validfrom,validto,assessmentType,attemptsAllowed} = arg.data;
      setTitle(name);
      setDesc(description);
      setExpiryDate(new Date(validto));
      setDuration(duration);
      setThreshold(passpercentage);
      setType(assessmentType);
      setAttemptsAllowed(attemptsAllowed)
    }
  }, [])
  

  //Save new asessment
  const saveAssessment = ()=>{
    setShow(false);
      const req = {
        name:title,
        description:desc,
        validfrom:new Date().toISOString().split('T')[0],
        validto:expiryDate.toISOString().split('T')[0],
        passpercentage:threshold,
        duration,
        assessmentType:type,
        attemptsAllowed
      };
      arg.createCb(req)
  }
  //Edit Assessment
  const editAssessment = ()=>{
    setShow(false);
      const req = {
        id : arg.data.id,
        name:title,
        description:desc,
        validfrom:new Date(arg.data.validfrom).toISOString().split('T')[0],
        validto:expiryDate.toISOString().split('T')[0],
        passpercentage:threshold,
        duration,
        assessmentType:type,
        attemptsAllowed
      };
      arg.editCb(req)
  }
    //edit questions
    const editQuestions=()=>{
      arg.editQ();
    }

  return (
    <>
      <Modal show={show} onHide={handleClose}  backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title>{arg.edit ? "Edit Assessment" : "Add New Assessment"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text" onChange={(e)=>setTitle(e.target.value)} value={title} autoFocus
              />
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Description</Form.Label>
              <Form.Control as="textarea" rows={2} onChange={(e)=>setDesc(e.target.value)} value={desc}/>
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Threshold</Form.Label>
              <Form.Control type="number" min="1" max="100"  onChange={(e)=>setThreshold(e.target.value)} value={threshold}/>
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Allowed Attempts</Form.Label>
              <Form.Control type="number" min="1" max="100"  onChange={(e)=>setAttemptsAllowed(e.target.value)} value={attemptsAllowed}/>
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Duration(In Minutes)</Form.Label>
              <Form.Control type="number" min="1"   onChange={(e)=>setDuration(e.target.value)} value={duration}/>
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Type</Form.Label>
              <select className='form-control'  onChange={(e)=>setType(e.target.value)} value={type} >
                <option></option>
                <option value='1'>Objective</option>
                <option value='2'>Interactive</option>
                <option value='3'>Descriptive</option>
              </select>
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Expiry Date</Form.Label>
              <DatePicker dateFormat="yyyy/MM/dd" minDate={todayDate} selected={(arg.edit && checkFlag.current===0)?new Date(arg.data.validto):expiryDate} onChange={(date) =>{ checkFlag.current=1; setExpiryDate(date)}} className='form-control'/>
            </Form.Group>
            
          </Form>
        </Modal.Body>
        <Modal.Footer>
        {
            arg.edit ? <Button variant="warning" onClick={editQuestions} >
            EDIT QUESTIONS
          </Button> : ''
          }
          <Button variant="secondary" onClick={handleClose}>
            CANCEL
          </Button> 
          {
            arg.edit ?  <Button variant="primary" onClick={editAssessment}>
            SAVE
          </Button> :  <Button variant="primary" onClick={saveAssessment}>
            SAVE
          </Button>
          }
         
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddAssessment;

